// Formatting helpers shared by the command-center rollup cards + program grid.
// Kept local to CommandCenter; the delivery home has its own `formatCurrency`
// for single-program values, but these tolerate the rollup's raw doubles
// (which can legitimately be 0) and render a compact dash for empties.
export function fmtUsd(amount) {
    if (amount == null) return '—';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    }).format(amount);
}
export function fmtPct(value) {
    if (value == null) return '—';
    return `${value.toFixed(1)}%`;
}
export function fmtCount(value) {
    if (value == null) return '—';
    return Number(value).toLocaleString();
}
